module.exports = __webpack_public_path__ + "img/ranking-municipal.d65dd2a1.png";